module.exports = __webpack_public_path__ + "static/media/small_audi.a26bb1fb.png";